import React from 'react';
import { motion } from 'framer-motion';
import { Fingerprint } from './Fingerprint';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-294">
      <motion.div whileHover={{
      rotate: 5,
      scale: 1.05
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 20
    }} data-id="element-295">
        <Fingerprint className="w-9 h-9 text-brand-primary" data-id="element-296" />
      </motion.div>
      <span className="text-[clamp(1.3rem,2.5vw,1.6rem)] font-black tracking-[-0.02em]" data-id="element-297">
        <span className="text-white" data-id="element-298">Core</span>
        <span className="text-brand-primary" data-id="element-299">Print</span>
      </span>
    </div>;
}